module.exports = __webpack_public_path__ + "img/Red_Circle_Checkmark.de67176f.png";